import React from 'react';
import CTAButton from './CTAButton';
export function FinalCTA() {
  return <section className="py-8 px-4 bg-gradient-to-b from-black to-gray-900 text-white" data-id="element-152">
      <div className="max-w-4xl mx-auto text-center" data-id="element-153">
        <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-154">
          👉 HAZ CLIC AHORA Y ACCEDE
        </h2>

        <p className="text-2xl mb-3" data-id="element-155">No lo dejes para después.</p>
        <p className="text-2xl mb-3" data-id="element-156">El mejor momento para enseñar dinero…</p>
        <p className="text-3xl font-bold mb-6 text-yellow-400" data-id="element-157">es HOY.</p>

        <div className="bg-gradient-to-r from-yellow-400 to-orange-500 p-5 rounded-lg mb-6" data-id="element-158">
          <h3 className="text-2xl md:text-4xl font-black text-black mb-3" data-id="element-159">
            💬 ÚLTIMO MENSAJE
          </h3>
          <p className="text-xl text-black mb-2" data-id="element-160">
            No estás comprando un ebook.
          </p>
          <p className="text-xl text-black mb-2" data-id="element-161">
            Estás cambiando el futuro de tu hijo.
          </p>
          <p className="text-2xl font-bold text-black" data-id="element-162">Y eso…</p>
          <p className="text-2xl font-bold text-black" data-id="element-163">no tiene precio.</p>
        </div>

        <CTAButton text="🔘 QUIERO ACCEDER AHORA" data-id="element-164" />

        <div className="mt-6 text-sm text-gray-400" data-id="element-165">
          <p data-id="element-166">
            ✅ Acceso inmediato • ✅ Garantía de 7 días • ✅ Pago 100% seguro
          </p>
        </div>
      </div>
    </section>;
}
export default FinalCTA;